// extracted by mini-css-extract-plugin
export var sliderRange = "_pb-2";
export var sliderRoot = "_pb-0";
export var sliderThumb = "_pb-3";
export var sliderTrack = "_pb-1";